import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Box, capitalize, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { mealFilterSubtypes, OrderByFilterOption, orderByFilterVar, typeFilterVar } from 'context'
import { useSegmentInteraction } from 'hooks/analytics/segment'
import { filteringOnlyByMealSubtypes, selectMealSubtypes } from './helpers'

export const OrderByFilter = () => {
  const orderByFilter = useReactiveVar(orderByFilterVar)
  const { track } = useSegmentInteraction()

  useEffect(() => {
    const canFilterByAnySubtype = orderByFilter === OrderByFilterOption.Default
    if (canFilterByAnySubtype) {
      return
    }

    const currentFilteredTypes = typeFilterVar()

    const filterByAllMealSubtypes = () => typeFilterVar(mealFilterSubtypes)

    const mealSubtypes = selectMealSubtypes(currentFilteredTypes)
    const isNotFilteringByAnyMealSubtype = mealSubtypes.length === 0

    if (isNotFilteringByAnyMealSubtype) {
      filterByAllMealSubtypes()
      return
    }

    const keepOnlyMealSubtypes = () => {
      const mealSubtypes = selectMealSubtypes(currentFilteredTypes)
      typeFilterVar(mealSubtypes)
    }

    if (!filteringOnlyByMealSubtypes(currentFilteredTypes)) {
      keepOnlyMealSubtypes()
    }
  }, [orderByFilter])

  const handleOnChange = (event: SelectChangeEvent<string>) => {
    const nextValue = event.target.value
    track('Events "order by" filter changed', { filterValue: nextValue })
    orderByFilterVar(nextValue)
  }

  return (
    <Box sx={{ flexGrow: 1, minWidth: 130 }} marginLeft={1}>
      <Select
        sx={{ width: '100%' }}
        color="secondary"
        size="small"
        value={orderByFilter}
        onChange={handleOnChange}
      >
        <MenuItem disabled value="">
          <Typography>Order by</Typography>
        </MenuItem>

        {Object.values(OrderByFilterOption).map((value: string) => (
          <MenuItem key={value} value={value}>
            {value === OrderByFilterOption.Default ? 'Occurred At' : capitalize(value)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
